import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dw_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("dw_cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.product_id);
      if (found) {
        return prev.map((i) => i.product_id === product.product_id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, { product_id: product.product_id, name: product.name, price_usd: product.price_usd, image: product.images?.[0], coming_soon: !!product.coming_soon, quantity: qty }];
    });
    toast.success(`${product.name} added to cart`);
    setOpen(true);
  }, []);

  const updateQty = useCallback((product_id, quantity) => {
    if (quantity <= 0) { setItems((prev) => prev.filter((i) => i.product_id !== product_id)); return; }
    setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, quantity } : i));
  }, []);

  const removeItem = useCallback((product_id) => {
    setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price_usd * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearCart, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
